<template>
  <div class="item cart-item d-flex align-items-center py20-sm py15 pt0-sm bb-darkgray relative">
    <div class="d-flex">
      <div class="img-wrapper">
        <img
          :src="
            item.product.cover_small_source || 'https://via.placeholder.com/80x80'
          "
          alt=""
          class="img-fluid"
        />
        <span class="item-qty">
          {{ item.quantity }}
        </span>
      </div>
      <div class="details-wrapper px20-md px10">
        <p class="mb10 title ff-nunito-bold text-left">
          {{ item.product.title }}
        </p>
        <p class="mb10 variant">
          {{ item.subtitle }}
        </p>
      </div>
      <div class="price-wrapper pl20-md pr30-md">
        <p class="mb10 ff-nunito-bold text-nowrap">
          {{ item.unit_price | moneyToCurrencyFormat }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: Object
  }
};
</script>

<style lang="scss" scoped>
.img-wrapper {
  flex: 1 0 80px;

  img {
    width: 80px;
    object-fit: cover;
  }
}
</style>
